import { ICelebrusFailedATBEvent, ICelebrusSuccessfulATBEvent } from 'types/CelebrusTypes';

const sendCelebrusEvent = (event: ICelebrusSuccessfulATBEvent | ICelebrusFailedATBEvent): void => {
  window.veryv9csaCelebrusApi?.event(event);
};

export default sendCelebrusEvent;
